import React from 'react';

import { initialsFromName } from '../lib/mandate-helpers';

// Single client card used in the v3 Clients list (cards mode).
//
// Layout matches the design spec:
//   ┌──────────────────────────────────────┐
//   │ [mark]               [tier chip]     │
//   │                                      │
//   │ Client Name (serif)                  │
//   │ Sector · Region                      │
//   │                                      │
//   │ ─────────────────────                │
//   │ MANDATES    SINCE                    │
//   │ 7           2018                     │
//   │ Lead: Dean Birkett                   │
//   └──────────────────────────────────────┘

export type ClientTier = 'Strategic' | 'Growth' | 'Emerging';

interface Props {
  name: string;
  sector?: string;
  region?: string;
  tier?: ClientTier;
  mandates: number;
  since: number | string;
  lead?: string;
  onClick?: () => void;
}

const TIER_TONE: Record<ClientTier, string> = {
  Strategic: 'gold',
  Growth: 'info',
  Emerging: 'muted'
};

const ClientCard = ({ name, sector, region, tier, mandates, since, lead, onClick }: Props) => (
  <article
    className="client-card"
    onClick={onClick}
    role={onClick ? 'button' : undefined}
    tabIndex={onClick ? 0 : undefined}
    onKeyDown={
      onClick
        ? (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              onClick();
            }
          }
        : undefined
    }
  >
    <div className="top">
      <div className="mark">{initialsFromName(name)}</div>
      {tier ? <span className={`chip ${TIER_TONE[tier]}`}>{tier}</span> : <span />}
    </div>

    <div>
      <h3>{name}</h3>
      <div className="meta">{[sector, region].filter(Boolean).join(' · ') || '—'}</div>
    </div>

    <div className="footer">
      <div className="col">
        <span className="label">Mandates</span>
        <span className="value">{mandates}</span>
      </div>
      <div className="col">
        <span className="label">Since</span>
        <span className="value">{since}</span>
      </div>
    </div>

    {lead && (
      <div className="lead">
        Lead: <strong>{lead}</strong>
      </div>
    )}
  </article>
);

export default ClientCard;
